import { render } from "./PaymentMethod.vue?vue&type=template&id=6747bb1e&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"

import "./PaymentMethod.vue?vue&type=style&index=0&id=6747bb1e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6747bb1e"

export default script